import { View } from 'react-native';

import { ProgressBar } from '@/components/ui/ProgressBar';

import { Body } from './Body';
import { BodySemibold } from './BodySemibold';
import { Display } from './Display';
import { Eyebrow } from './Eyebrow';
import { Mono } from './Mono';
import { Tick } from './Tick';

const HERO_DONE = [
  { label: 'Obtain ATIS / AWOS', who: 'JM' },
  { label: 'Complete approach briefing', who: 'AR' },
];
const HERO_TODO = ['Set altimeter', 'Set HDG indicator', 'Fuel Selector Valve: Both'];

export function PhoneMockup() {
  return (
    <View
      className="w-[320px] rounded-[44px] bg-ink p-[9px]"
      style={{ boxShadow: '0 30px 60px -22px rgba(0,0,0,0.5)' }}
    >
      <View className="overflow-hidden rounded-[36px] bg-background">
        {/* status bar */}
        <View className="h-[46px] flex-row items-end justify-between px-6 pb-1.5">
          <BodySemibold className="text-sm text-foreground">9:41</BodySemibold>
          <View className="flex-row items-center gap-1.5">
            <BodySemibold className="text-[11px] text-foreground">5G</BodySemibold>
            <View className="h-[11px] w-[22px] justify-center rounded-[3px] border-[1.5px] border-foreground p-[1.5px]">
              <View className="h-full w-[13px] rounded-[1px] bg-foreground" />
            </View>
          </View>
        </View>

        {/* run header */}
        <View className="px-[22px] pb-3.5 pt-1.5">
          <Eyebrow className="mb-2 text-[10px] tracking-[0.16em] text-faint">RUN</Eyebrow>
          <Display className="text-[21px] tracking-[-0.01em] text-foreground">
            Cessna 172D-H Approach
          </Display>
          <View className="mt-3 flex-row items-center gap-2.5">
            <ProgressBar value={2} total={7} className="flex-1" />
            <Mono className="text-xs text-foreground-secondary">2 / 7</Mono>
          </View>
        </View>

        {/* items */}
        <View className="gap-2 px-4 pb-4 pt-0.5">
          {HERO_DONE.map((item) => (
            <View
              key={item.label}
              className="flex-row items-center gap-3 rounded-[13px] border border-border bg-card px-3 py-3"
            >
              <Tick checked />
              <Body className="flex-1 text-[14.5px] text-faint line-through">
                {item.label}
              </Body>
              <Mono className="text-[10px] text-faint">{item.who}</Mono>
            </View>
          ))}
          {HERO_TODO.map((label) => (
            <View
              key={label}
              className="flex-row items-center gap-3 rounded-[13px] border border-border bg-card px-3 py-3"
            >
              <Tick checked={false} />
              <Body className="flex-1 text-[14.5px] text-foreground-secondary">
                {label}
              </Body>
            </View>
          ))}
        </View>

        {/* home indicator */}
        <View className="items-center pb-2">
          <View className="h-[5px] w-[120px] rounded-full bg-foreground" />
        </View>
      </View>
    </View>
  );
}
